import { render, staticRenderFns } from "./DeleteAnUnattachedDocument.vue?vue&type=template&id=4c8e51fb&scoped=true"
import script from "./DeleteAnUnattachedDocument.vue?vue&type=script&lang=js"
export * from "./DeleteAnUnattachedDocument.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c8e51fb",
  null
  
)

export default component.exports